<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Listado de grupos" :breadcrumb="true" />
			</template>
			<template #actions>
				<div class="hstack gap-2 justify-content-md-end">
					<router-link :to="{ name: 'company.admin.group.create' }" class="btn btn-sm btn-dark rounded-pill flex-shrink-0">Nuevo</router-link>
				</div>
			</template>
		</LayoutHeaderSection>
		<main class="pt-5 pb-10 pb-0 vstack gap-10">
			<LayoutTableMain :results="results" :loading="loading" @goPage="goPage">
				<template #filters>
					<div class="input-group input-group-sm rounded-pill">
						<span class="input-group-text bg-white rounded-start-pill pe-0" id="basic-addon1"><i class="bi bi-search"></i></span>
						<input type="text" v-model="filters.search" class="form-control border-start-0 rounded-end-pill" placeholder="Buscar..." />
					</div>
				</template>
				<template #body>
					<CompanyAdminGroupTableRow v-for="data in results?.data" v-bind:key="data.id" :group="data" @remove="remove" />
				</template>
			</LayoutTableMain>
		</main>

		<CommonModalAction ref="modalRemove" title="Eliminar grupo" description="¿Desea eliminar este grupo? Al eliminarlo, desasignará a los clientes" submitText="Eliminar" submitClass="btn-danger" :target="target" @success="destroy" />
	</div>
</template>

<script>
	import { ref, reactive, watch, onMounted } from 'vue';
	import router from '@/router';
	import store from '@/store';
	import composableForm from '@/composables/form';
	import CompanyAdminGroupRepository from '@/repositories/modules/Company/Admin/Group';

	export default {
		setup() {
			const { loading, catchError } = composableForm();
			const results = ref({});
			const filters = reactive({
				search: null,
				orderBy: 'name',
				orderMethod: 'asc',
				take: 20,
				page: 1
			});

			const target = ref(null);
			const modalRemove = ref(null);
			const remove = (group) => {
				target.value = group;
				modalRemove.value.show();
			}
			const destroy = (group) => {
				CompanyAdminGroupRepository.destroy(group.id).then(getResults).catch((e) => catchError(e, true));
			}

			const getResults = async () => {
				loading.value = true;

				await CompanyAdminGroupRepository.index(filters).then((response) => {
					results.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'company.admin.home' });
				});

				loading.value = false;
			}

			const goPage = (page) => {
				filters.page = page;
				getResults();
			}

			const timeout = ref(null);
			watch(() => filters.search, () => {
				if(timeout.value) clearTimeout(timeout.value);
				timeout.value = setTimeout(() => goPage(1), 1000);
			});

			onMounted(getResults);

			return { loading, filters, results, goPage, target, modalRemove, remove, destroy };
		}
	}
</script>